module.exports = __webpack_public_path__ + "static/img/102758.a073c6f5.png";